/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/*
numberToKorean(200000, 'normal') 이십만
numberToKorean(100020003000, 'lingual') 천억이천만삼천
numberToKorean(100020003000, 'mixed') 1,000억 2,000만 3,000
numberToKorean(100020003000, 'spacing') 일천억 이천만 삼천
numberToKorean(100020003000, 'mixed_number') 1,000억2,000만2천
*/

// 한글로 바꿀 숫자 배열
const textSymbol = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
// 4자리마다 반복되는 자릿수 배열
const powerSymbol = ['', '십', '백', '천'];
// 4자리마다 커지는 단위수 배열
const dotSymbol = ['', '만', '억', '조', '경'];

function splitEvery(n: number, arr = []) {
  const result: any[] = [];
  let index = 0;

  while (index < arr.length) {
    result.push(arr.slice(index, (index += n)));
  }

  return result;
}

function dropLastWhile(pred: any, arr: any[]) {
  let index = arr.length - 1;
  while (index >= 0 && pred(arr[index])) {
    index -= 1;
  }

  return arr.slice(0, index + 1);
}

export const FormatOptions = {
  // 일반
  NORMAL: 'normal',
  // 띄어쓰기
  SPACING: 'spacing',
  // 한글 숫자 병기
  MIXED: 'mixed',
  // 한글 숫자 병기2
  MIXED_NUMBER: 'mixed_number',
  // 구어체
  LINGUAL: 'lingual',
  // 구어체 띄어쓰기
  LINGUAL_SPACING: 'lingual_spacing',
};

export class NumToKorean {
  originNum = 0;

  token: any;

  result: any;

  formatOption: string;

  constructor(num: number, options: any) {
    this.formatOption = 'normal';
    this.token = [];
    this.result = [];
    this.originNum = this.isInteger(num) ? num : 0;
    this.formatOption = options;
  }

  isInteger(num: number): boolean {
    return Number.isFinite(num) && Math.floor(num) === num;
  }

  getToken() {
    this.token = this.originNum
      .toString()
      .split('')
      .map(numText => parseInt(numText, 10))
      .reverse()
      .map((num, index) => {
        const powerIndex = index % 4;
        const dotIndex = Math.ceil(index / 4);
        const power = num === 0 ? '' : powerSymbol[powerIndex];
        const dot = powerIndex === 0 ? dotSymbol[dotIndex] : '';

        return { num, power, dot };
      });

    return this;
  }

  flatToken(isMixed: boolean) {
    this.result = this.token.map((item: any, index: number) => {
      if (isMixed) {
        return `${item?.num}${item.power && item.dot ? item.dot : item.dot}`;
      }
      const numToText = textSymbol[item.num] || '';
      return `${numToText}${item.power}${item.dot}`;
    });

    return this;
  }

  reverseTokenDropZero() {
    this.result = splitEvery(4, this.result)
      .map(item => {
        const droppedZero = dropLastWhile(
          (x: any) => parseInt(x, 10) === 0,
          item
        );

        if (droppedZero.length === 4) {
          droppedZero.splice(3, 0, ',');
        }

        return droppedZero;
      })
      .reduce((acc, val) => acc.concat(val), [])
      .reverse();

    return this;
  }

  tokenDropZero() {
    this.result = splitEvery(4, this.result)
      .map(item => {
        const droppedZero = dropLastWhile(
          (x: any) => parseInt(x, 10) === 0,
          item
        );

        if (droppedZero.length === 3) {
          droppedZero.slice(3);
        }

        return droppedZero;
      })
      .reduce((acc, val) => acc.concat(val), [])
      .reverse();

    return this;
  }

  reverseToken() {
    this.result = splitEvery(4, this.result)
      .map((item: any[]) =>
        dotSymbol.indexOf(item.join('')) > 0 ? ['', '', '', ''] : item
      )
      .reduce((acc, val) => acc.concat(val), [])
      .reverse();

    return this;
  }

  addSpacing() {
    this.result = this.result
      .filter((token: any) => token)
      .map((token: any) => {
        if (dotSymbol.indexOf(token.slice(-1)) > 0) {
          return `${token} `;
        }
        return token;
      });

    return this;
  }

  removeOneStr() {
    if (this.result.length === 1) {
      return this;
    }

    const filtered: any[] = [];

    for (let i = 0; i < this.result.length; i += 1) {
      // 일의자리의 "일"은 생략되어선 안 된다
      if (i === this.result.length - 1) {
        filtered.push(this.result[i]);
        break;
      }

      // 십만자리 이상일 때 만, 억, 조 단위의 "일"은 생략되어선 안 된다
      // 다만 만의자리일 때 만의자리의 "일"은 생략되어야 한다
      if (
        this.result.length > 5 &&
        dotSymbol.indexOf(this.result[i].slice(1)) > 0
      ) {
        filtered.push(this.result[i]);
        continue;
      }

      // 그 외의 "일"은 생략된다
      if (this.result[i].slice(0, 1) === textSymbol[1]) {
        filtered.push(this.result[i].slice(1));
      } else {
        filtered.push(this.result[i]);
      }
    }

    this.result = filtered;
    return this;
  }

  makeZeroIfResultEmpty() {
    if (
      (this.result.length === 1 && this.result[0] === '') ||
      this.result.length === 0
    ) {
      this.result = ['0'];
    }
    return this;
  }

  getResult() {
    return this.result;
  }

  getNormal() {
    return this.getToken().flatToken(false).reverseToken().getResult().join('');
  }

  getLingual() {
    return this.getToken()
      .flatToken(false)
      .reverseToken()
      .removeOneStr()
      .getResult()
      .join('');
  }

  getSpacing() {
    return this.getToken()
      .flatToken(false)
      .reverseToken()
      .addSpacing()
      .getResult()
      .join('')
      .trim();
  }

  getLingualSpacing() {
    return this.getToken()
      .flatToken(false)
      .reverseToken()
      .removeOneStr()
      .addSpacing()
      .getResult()
      .join('')
      .trim();
  }

  makeThousands() {
    if (this.result.length > 3) {
      this.result.splice(this.result.length - 3, 3);
      this.result[this.result.length - 1] = `${
        this.result[this.result.length - 1]
      }천`;
    }
    return this;
  }

  getMixed() {
    return this.getToken()
      .flatToken(true)
      .reverseTokenDropZero()
      .addSpacing()
      .makeZeroIfResultEmpty()
      .getResult()
      .join('')
      .trim();
  }

  getMixedNumber() {
    return this.getToken()
      .flatToken(true)
      .tokenDropZero()
      .makeZeroIfResultEmpty()
      .makeThousands()
      .getResult()
      .join('');
  }

  getKorean() {
    if (this.formatOption === FormatOptions.SPACING) {
      return this.getSpacing();
    }

    if (this.formatOption === FormatOptions.MIXED) {
      return this.getMixed();
    }

    if (this.formatOption === FormatOptions.MIXED_NUMBER) {
      return this.getMixedNumber();
    }

    if (this.formatOption === FormatOptions.LINGUAL) {
      return this.getLingual();
    }

    if (this.formatOption === FormatOptions.LINGUAL_SPACING) {
      return this.getLingualSpacing();
    }

    if (this.formatOption === FormatOptions.NORMAL) {
      return this.getNormal();
    }

    return this.getNormal();
  }
}

/**
 * {{numToKorean 20000 'normal'}}
 * @param num
 * @param formatOptions
 * @returns
 */
function numberToKorean(
  num: number,
  formatOptions = FormatOptions.NORMAL
): string {
  const k = new NumToKorean(num, formatOptions);

  return k.getKorean();
}

export default numberToKorean;
